import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { configure_getting_started_progress, configure_progress } from "../../../actions/globalAction";
import "./content.scss";
import { Link } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";
import { ReactComponent as SettingsIcon } from "../../../assets/svg/settings.svg";
import { setActiveModule } from "../../../actions/sideBarActions";

const SMPSettings = () => {
    // const user = useSelector((state) => state.globalReducer.user);
    const dispatch = useDispatch();

    // useEffect(() => {
    // let obj = {
    //     progress_config: {
    //         smp_settings: 1,
    //     },
    // };
    // console.log("first", user.roles);
    // if (user.roles.indexOf("smp_manager") < 0 && user.roles.indexOf("companyadmin") < 0 && user.roles.indexOf("admin") < 0)
    //     dispatch(configure_getting_started_progress(obj));
    // }, []);

    const configureProgress = () => {
        let obj = {
            progress_config: {
                smp_settings: 1,
            },
        };
        localStorage.setItem("activeModule", "Publishing");
        dispatch(setActiveModule("Publishing"));
        dispatch(configure_getting_started_progress(obj));
    };
    return (
        <>
            <div className="gs_content">
                <div className="left_content">
                    <div className="gs_header">
                        {/* <Icon name="user" size="large" className="icon_content" color="#268af6" width="20px" height="20px" /> */}
                        <SettingsIcon className="icon_content fill_svg" />
                        <span className="content_title">Publishing Settings</span>
                    </div>
                    <div className="text_content">
                        <p>{`Settings section will help you to connect your social media profiles to the Publishing Module.  Click on “Add Pages” to start connecting your accounts. Authenticating your account will help you to publish content on those pages. `}</p>
                        <p>
                            There are 2 roles you can configure. Agents can create and schedule content but need to send it a manager for approval before the
                            post can be published.
                        </p>
                        <p>Managers can create, schedule and publish content.</p>
                        {/* <p>{`Some of the reports and other functionality use your time zone to work properly.  You can control your time zone from here.`}</p> */}
                    </div>
                    {/* {["smp_manager", "companyadmin", "admin"].some((role) => user?.roles.includes(role)) && ( */}
                    <Link to="/social-media-publishing/settings">
                        <button className="gs_link" onClick={() => configureProgress()}>
                            Explore
                        </button>
                    </Link>
                    {/* )} */}
                </div>
                <div className="right_content">
                    <div id="gs_loader">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Loading</Loader>
                        </Dimmer>
                    </div>
                    <iframe
                        width="320px"
                        height="200px"
                        src="https://www.youtube.com/embed/QB2vjD8eIiQ"
                        title=""
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                        allowFullScreen
                        onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                        className="content_video"></iframe>
                    {/* <img className="content-img" src={profileImg} width="350px" height="200px" /> */}
                </div>
            </div>
        </>
    );
};

export default SMPSettings;
